import { render, staticRenderFns } from "./ArticleDetailed.vue?vue&type=template&id=b8e04864&scoped=true&"
import script from "./ArticleDetailed.vue?vue&type=script&lang=js&"
export * from "./ArticleDetailed.vue?vue&type=script&lang=js&"
import style0 from "./ArticleDetailed.vue?vue&type=style&index=0&id=b8e04864&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e04864",
  null
  
)

export default component.exports